import {
	type AssociationResponse,
	AssociationStatus,
} from '~~/openapi-client/gen/schemas'

export default function useCreatorAssociations() {
	const { $api } = useNuxtApp()
	const isEmpty = computed(() => associations.value?.length === 0)
	const createdAssociation = computed(() => associations.value?.find(association => association.status === AssociationStatus.CREATED))
	const existsCreatedAssociation = computed(() => createdAssociation.value !== undefined)

	const { refresh, data: associations } = useAsyncData('creatorAssociations', () => $api.associationApi.findByCreatorAccount(), {
		immediate: false,
		default: () => [] as AssociationResponse[],
		transform: associations => (associations?.data) as AssociationResponse[] ?? undefined,
	})

	return {
		isEmpty,
		associations,
		createdAssociation,
		existsCreatedAssociation,
		refresh,
	}
}
